var _desc, _rect, _rect2, _circle, _path, _path2, _rect3, _rect4, _rect5, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 675",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Project placeholder thumbnail") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A simple placeholder image for portfolio project cards.")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 675,
    rx: 28,
    fill: "#f5f6f8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 48,
    width: 1104,
    height: 579,
    rx: 18,
    fill: "none",
    stroke: "#9aa3ad",
    strokeWidth: 4,
    strokeDasharray: "18 18"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 250,
    r: 62,
    fill: "#d9dee5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170 505 365 310 485 430 565 350 775 560H170Z",
    fill: "#d0d6df"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M485 430 565 350 775 560H575Z",
    fill: "#bcc5d0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 685,
    y: 215,
    width: 330,
    height: 32,
    rx: 16,
    fill: "#c6cdd6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 685,
    y: 282,
    width: 245,
    height: 28,
    rx: 14,
    fill: "#d9dee5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 685,
    y: 343,
    width: 285,
    height: 28,
    rx: 14,
    fill: "#d9dee5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 685,
    y: 438,
    width: 180,
    height: 52,
    rx: 26,
    fill: "#c6cdd6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectPlaceholder);
export default __webpack_public_path__ + "static/media/project-placeholder.adca41589d1ae68592d293d678ee9431.svg";
export { ForwardRef as ReactComponent };